import React, { Fragment, useRef, useState } from 'react';
import { Button, Flex, Text } from 'rebass';
import { compose, withApollo } from 'react-apollo';
import { withWizard } from 'react-albus';
import gql from 'graphql-tag';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import styled from 'styled-components';
import Mailcheck from 'react-mailcheck';

import { TextInputWithLabel } from '../../components/TextInput';
import { FormField } from '../../components/FormField';
import { withRouter } from 'react-router';
import { isMobile } from 'react-device-detect';
import { EMAIL_AVAILABLE } from '../../graphql';
import { sleep } from '../../utils/sleep';
import SpinLoader from '../../components/SpinLoader';

// const EMAIL_AVAILABLE = gql`
//   query EmailAvailable($email: String!) {
//     emailAvailable(email: $email) {
//       ok
//       mobile
//     }
//   }
// `;

const MailcheckWrapper = styled.div`
  text-align: right;
  @media screen and (max-width: 52em) {
    text-align: left;
  }
`;

const MailcheckButton = styled(Button)`
  padding: 0;
  border: none;
  background: none;
  font-size: inherit;
  font-style: italic;
  color: rgb(237, 183, 168);
  cursor: pointer;
  text-decoration: underline;
  text-underline-position: under;

  &:focus {
    outline: none;
    color: rgb(237, 183, 168);
  }

  &:hover {
    color: rgb(237, 183, 168);
  }

  &:active {
    color: rgb(237, 183, 168);
  }
`;

const Basic = (props) => {
  const EmailRef = useRef(null);
  const PasswordRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handlePasswordClick = () => {
    if (PasswordRef.current) {
      PasswordRef.current.focus();
    }
  };
  const handleEmailClick = () => {
    if (EmailRef.current) {
      EmailRef.current.focus();
    }
  };

  const submitCheck = async (values, actions) => {
    try {
      setIsLoading(true);
      const { data } = await props.client.query({
        query: EMAIL_AVAILABLE,
        variables: {
          email: values.email,
        },
      });

      actions.setSubmitting(false);
      if (!data.emailAvailable.ok) {
        if (!!data.emailAvailable.mobile) {
          setIsLoading(false);
          props.history.push('/account-exists');
          return;
        }
        setIsLoading(false);
        throw Error('Email already in use');
      } else {
        setIsLoading(false);
        props.onSubmit(values, actions, props.wizard);
      }
    } catch (error) {
      setIsLoading(false);
      actions.setSubmitting(false);
      actions.setFieldError('email', error.message);
    }
  };

  let schema = Yup.object().shape({
    email: Yup.string()
      .email('Invalid email')
      .required('Required'),
    password: Yup.string()
      .trim()
      .min(8, 'Password must be greater than 8 characters')
      .required('Required'),
  });

  return (
    <Fragment>
      <Flex mb={4} flex={1} flexDirection={['column', 'column', 'row']}>
        <Flex flex={1} mb={[4, 4, 0]}>
          <Flex flexDirection="column" flex={1}>
            <Text style={{ fontSize: isMobile ? '26px' : '32px', fontWeight: 500 }} mb={2}>
              Create Your Account
            </Text>
            <Text style={{ fontSize: isMobile ? '16px' : '18px' }} mb={5}>
              Creating an account is free!
            </Text>

            <Formik
              isInitialValid={({ initialValues }) => schema.isValidSync(initialValues)}
              initialValues={props.state}
              validationSchema={schema}
              onSubmit={async (values, actions) => {
                actions.setSubmitting(true);
                await sleep(200);
                await submitCheck(values, actions);
              }}
              render={({ isValid, errors, touched, handleChange, handleBlur, setFieldValue, values, submitForm, isSubmitting }) => {
                return (
                  <Form style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <Flex flexDirection={'column'} flex={1}>
                      <FormField mb={3} error={touched.email && errors.email}>
                        <Mailcheck email={values.email}>
                          {(suggestion) => (
                            <>
                              <Flex
                                flex={1}
                                flexDirection={'row'}
                                onClick={handleEmailClick}
                                style={{ border: `1px solid #909ebb`, borderRadius: '12px', padding: '12px 0px 0px 0px', background: 'white', cursor: 'pointer', alignItems: 'center' }}
                              >
                                <Flex flex={1} flexDirection={'column'}>
                                  <TextInputWithLabel
                                    style={{ border: 0, background: 'white', color: '#344f79', fontSize: isMobile ? '14px' : '' }}
                                    subref={EmailRef}
                                    placeholder="Your Email Address"
                                    type="email"
                                    name="email"
                                  />
                                </Flex>
                              </Flex>
                              {suggestion && (
                                <MailcheckWrapper className="mailcheck">
                                  Did you mean{' '}
                                  <MailcheckButton type="button" onClick={() => setFieldValue('email', suggestion.full)}>
                                    {suggestion.full}
                                  </MailcheckButton>
                                  ?
                                </MailcheckWrapper>
                              )}
                            </>
                          )}
                        </Mailcheck>
                      </FormField>

                      <FormField mb={3} error={touched.password && errors.password}>
                        <Flex
                          flexDirection={'row'}
                          onClick={handlePasswordClick}
                          style={{ border: `1px solid #909ebb`, borderRadius: '12px', padding: '12px 0px 0px 0px', background: 'white', cursor: 'pointer', alignItems: 'center' }}
                        >
                          <Flex flex={1} flexDirection={'column'}>
                            <TextInputWithLabel
                              style={{ border: 0, background: 'white', color: '#344f79', fontSize: isMobile ? '14px' : '' }}
                              subref={PasswordRef}
                              placeholder="Your Password"
                              type="password"
                              name="password"
                              id="input_password"
                            />
                          </Flex>
                        </Flex>
                        {/* <TextInput placeholder="Your Password" type="password" name="password" id="input_password" /> */}
                      </FormField>
                    </Flex>

                    <Flex justifyContent="center" mt={4}>
                      {!!isLoading || !!isSubmitting || props.isCreating ? (
                        <SpinLoader />
                      ) : (
                        <Button variant="primary" width={[1 / 2, 1 / 3]} type="submit" disabled={!isValid || isLoading || isSubmitting} id="btn_next">
                          {isLoading || isSubmitting ? 'Please wait...' : 'Continue'}
                        </Button>
                      )}
                    </Flex>
                  </Form>
                );
              }}
            />
          </Flex>
        </Flex>
      </Flex>
    </Fragment>
  );
};

export default compose(
  withApollo,
  withWizard,
  withRouter
)(Basic);
